"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceScheduleType = void 0;
var DataSourceScheduleType;
(function (DataSourceScheduleType) {
    DataSourceScheduleType["NIGHTLY"] = "NIGHTLY";
    DataSourceScheduleType["SIX_HOURS"] = "SIX_HOURS";
    DataSourceScheduleType["HOURLY"] = "HOURLY";
    DataSourceScheduleType["FIVE_MINUTES"] = "FIVE_MINUTES";
    DataSourceScheduleType["NEVER"] = "NEVER";
})(DataSourceScheduleType = exports.DataSourceScheduleType || (exports.DataSourceScheduleType = {}));
//# sourceMappingURL=dataSourceScheduleType.js.map